import React, { useState } from "react";
import { formSteps, formStepsTitle } from "./Steps";
import { Button } from "components";
import { HeaderNavigation } from "components";
import { saveToFirebase, sendMkiEmail } from "services";
import { useToggle } from "hooks";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { Modal } from "components/Basic/Modal";
import Nicholas from "assets/Nicholas.png";

// starting values. Everything empty
const intialValues = {
  user_details: {
    partner_first_name: "",
    partner_last_name: "",
    partner_age: "",
    during_discussion: "",
    if_children_care_important: "",
    if_asset_divide_important: "",
    import_misc: "",
    user_first_name: "",
    user_last_name: "",
    user_age: "",
    user_email: "",
    user_phone: "",
  },
  relationship: {
    living_date: "",
    if_separated: "",
    separation_date: "",
    if_married: "",
    marriage_date: "",
    if_divorced: "",
    divorced_date: "",
    current_arrangements: "",
    if_amicable: "",
  },
  children: {
    if_children_together: "",
    if_children_partner_another: "",
    if_children_user_another: "",
    children_add: [
      // {
      // 	child_age: '',
      // 	child_gender: '',
      // 	child_parentage: ''
      // }
    ],
  },
  financial: {
    if_real_estate: "",
    real_estate_details: [
      // {
      // 	ownership: '',
      // 	value: '',
      // 	mortgage: ''
      // }
    ],
    user_income: "",
    user_employment_status: "",
    partner_income: "",
    partner_employment_status: "",
    user_bank_balance: "",
    partner_bank_balance: "",
    joint_bank_balance: "",
    user_super: "",
    partner_super: "",
    if_business: "",
    if_family_trust: "",
    if_shares: "",
    if_vehicle: "",
    if_overseas_property: "",
    if_inheritance: "",
    if_other_valuables: "",
    other_assets_totals: "",
    mortgage_who_pays: "",
    user_debt: "",
    partner_debt: "",
    joint_debt: "",
    if_user_struggles_debt: "",
    if_partner_struggles_debt: "",
    child_support_arrangements: "",
  },
  past_steps: {
    past_discussions_assets: "",
    past_discussions_children: "",
    if_court_assets: "",
    court_assets_summary: "",
    if_court_children: "",
    court_children_summary: "",
  },
};

const FormNavigationButtons = ({
  isLast,
  isFirst,
  steps,
  handleBackClick,
  onStartOver,
}) => {
  return (
    <section className={`flex flex-col h-12 items-center mt-2`}>
      {isLast ? (
        <Button
          type="submit"
          fontSize="lg"
          form="divorce-form"
          className="w-11/12 md:w-full md:max-w-xs mx-3 md:mx-0 focus:outline-none p-4 bg-native-200 hover:bg-native-300  hover:border-native-300"
        >
          Submit
        </Button>
      ) : steps === 7 || steps === 8 ? null : (
        <Button
          type="submit"
          fontSize="lg"
          form="divorce-form"
          className="w-32 mx-3 md:mx-0 p-2 py-1 mt-4 focus:outline-none bg-native-200 hover:bg-native-300  hover:border-native-300"
        >
          {steps > 2 ? "Save" : "Next"}
        </Button>
      )}
      {!isFirst && steps > 3 && (
        <div className=" italic mt-10 cursor-pointer" onClick={onStartOver}>
          <p> Start Over</p>
        </div>
      )}
    </section>
  );
};

export function DivorceForm() {
  // this state keeps track what step the form is up to.
  const [currentStep, setCurrentStep] = React.useState(0);
  const CurrentTab = formSteps[currentStep];

  // this is used to keep track of the form data that is saved
  const [formState, setFormState] = useState(intialValues);

  // these are just for toggles on the page
  const { toggleOn, onToggleClick } = useToggle();
  const { toggleOn: startOver, onToggleClick: onStartOver } = useToggle();
  const { toggleOn: redirect, onToggleClick: onRedirect } = useToggle();

  const isLastStep = () => currentStep === Object.keys(formSteps).length - 1;
  const isFirstStep = () => currentStep === 0 || currentStep === 1;

  // all the logic jumps is here.
  const handleDataTransform = (data) => {
    const [stepName] = Object.keys(data);
    console.log(stepName, "data---------", data);

    return data;
  };

  const onSubmit = (formData) => {
    setFormState((prevState) => ({ ...prevState, ...formData }));
    console.log("onSubmit Click - before handle", formData);
    const data = handleDataTransform(formData);
    console.log("onSubmit Click - after handle", data);
    if (isLastStep()) {
      console.log("onSubmit Click - after handle", data);
      saveToFirebase(data, setCurrentStep, onToggleClick);

      // sends email to mki legal
      sendMkiEmail({
        userEmail: data?.details?.email,
        userFirstName: "Action Plan Submitted",
        userLastName: data?.details?.last_name,
      });

      //setFormState(intialValues);
      return;
    } else if (currentStep === 6) {
      if (
        data.children.if_children_together === "Yes" ||
        data.children.if_children_partner_another === "Yes" ||
        data.children.if_children_user_another === "Yes"
      ) {
        setCurrentStep((prevStep) => prevStep + 1);
      } else {
        setCurrentStep((prevStep) => prevStep + 2);
      }
    } else {
      setCurrentStep((prevStep) => prevStep + 1);
    }

    window.scrollTo(0, 0);
  };
  const isLast = isLastStep();
  const isFirst = isFirstStep();

  const handleBackClick = (event) => {
    //	event.preventDefault();
    if (currentStep === 8) {
      if (
        formState.children.if_children_together.toLowerCase() === "yes" ||
        formState.children.if_children_partner_another.toLowerCase() ===
          "yes" ||
        formState.children.if_children_user_another.toLowerCase() === "yes"
      ) {
        setCurrentStep((prevStep) => prevStep - 1);
      } else {
        setCurrentStep((prevStep) => prevStep - 2);
      }
    } else if (currentStep > 0 && currentStep <= Object.keys(formSteps).length)
      setCurrentStep((prevStep) => prevStep - 1);

    window.scrollTo(0, 0);
  };

  const onNext = () => {
    if (currentStep >= 0 && currentStep < Object.keys(formSteps).length - 1)
      setCurrentStep((prevStep) => prevStep + 1);
    window.scrollTo(0, 0);
  };

  const resetForm = () => {
    setFormState(intialValues);
    setCurrentStep(0);
    onStartOver();
  };
  return (
    <div className="h-screen relative">
      <HeaderNavigation onStartOver={onStartOver} />
      <section
        className={`mx-auto w-5/6 md:w-2/3 lg:${
          currentStep <= 2 ? "w-1/2" : "w-2/5"
        } pt-16`}
      >
        {/* Main Section */}

        <section className="px-2 md:px-20 pt-10">
          {/* important. FormState is empty initially. It is updated on each next press and returning it the updated object.  */}
          <img
            src={Nicholas}
            className="w-20 h-20 m-auto border-blue-200 border-2 rounded-full"
            alt="user"
          />

          {currentStep > 2 ? (
            <div className="w-full mt-4 flex justify-between items-center">
              <section
                className="w-6 h-6 shadow bg-white flex justify-center items-center rounded-full cursor-pointer"
                onClick={handleBackClick}
              >
                <ArrowBackIosIcon style={{ width: 10 }} />
              </section>
              <span className="text-xl font-bold capitalize">
                {formStepsTitle[currentStep]}
              </span>
              <section
                className="w-6 h-6 rounded-full shadow bg-white flex justify-center items-center cursor-pointer"
                onClick={onNext}
              >
                <ArrowForwardIosIcon style={{ width: 10 }} />
              </section>
            </div>
          ) : null}

          {currentStep > 2 ? (
            // this is the progress bar
            <div className="w-full mt-4">
              <div className="w-full bg-gray-100 h-2 rounded overflow-hidden">
                <div
                  className="bg-native-300 text-xs leading-none h-2 text-center text-white rounded"
                  style={{
                    width: `${
                      (currentStep / (Object.keys(formSteps).length - 1)) * 100
                    }%`,
                  }}
                />
              </div>
            </div>
          ) : null}

          <CurrentTab
            onSubmit={onSubmit}
            store={formState}
            handleBackClick={handleBackClick}
          />
        </section>
        <FormNavigationButtons
          isLast={isLast}
          isFirst={isFirst}
          steps={currentStep}
          handleBackClick={handleBackClick}
          onStartOver={onStartOver}
        />
      </section>
      <footer className="self-center my-20 pb-20">
        <p className="text-center">
          Liability Limited by a scheme approved under Professional Standards
          Legislation.
        </p>
      </footer>

      <Modal onToggleClick={onToggleClick} toggleOn={toggleOn}>
        <p className="text-center text-3xl">Success</p>
        <p className="text-center">
          Thank you, we have received your information.
        </p>
        <p className="text-center">
          We be in touch shortly with arranging a discussion.
        </p>
        <div className="flex items-center justify-center mt-6	 ">
          <Button
            onClick={(e) => {
              setFormState(intialValues);
              setCurrentStep(0);
              e.preventDefault();
              window.location.href =
                "https://www.familylawassist.com.au/action-plan-thankyou/";
            }}
            className=" w-5/12 font-medium mx-3 md:mx-0 p-4 bg-native-200 hover:bg-native-300 shadow-lg border-native-200"
          >
            OKAY
          </Button>
        </div>
      </Modal>

      {/* <Modal onToggleClick={onRedirect} toggleOn={redirect}>
        <div className="flex flex-col w-full">
          <p className="text-center text-2xl">You Must Attend Counselling</p>

          <p className="text-left">
            For marriages lasting less than 2 years, the court requires both
            people to attend reconciliation counselling, just to make sure that
            reconciliation is not possible.
          </p>

          <p>
            After the reconciliation counselling session, if you both still
            decide that the relationship is over, the counsellor will issue a
            certificate to confirm you both attended the counselling session.{" "}
          </p>

          <p className="text-left">
            You can apply for divorce after you get this counselling certificate{" "}
          </p>

          <p className="text-left">
            You need to attend counselling unless you have a good reason.
          </p>

          <section className="w-full flex justify-around mt-5">
            <Button
              onClick={(e) => {
                e.preventDefault();
                window.location.href =
                  "https://www.familycourt.wa.gov.au/A/application_married_for_less_than_two_years.aspx";
              }}
              className="w-5/12  mx-3 md:mx-0 p-4 bg-gray-100 hover:bg-gray-200 font-medium text-gray-600 hover:text-gay-700 border-gray-200"
            >
              MORE INFORMATION
            </Button>
            <Button
              onClick={() => {
                setFormState(intialValues);
                setCurrentStep(0);
                onRedirect();
              }}
              className="w-5/12 font-medium mx-3 md:mx-0 p-4 bg-native-200 hover:bg-native-300 shadow-lg border-native-200"
            >
              RESTART QUESTIONS
            </Button>
          </section>
        </div>
      </Modal> */}

      <Modal onToggleClick={onStartOver} toggleOn={startOver}>
        <p className="text-center text-xl font-medium -mt-6">
          WANT TO START OVER?
        </p>
        <p className="text-center text-lg">
          This will clear your answers and start again from the beginning
        </p>
        <section className="w-full flex justify-around mt-5">
          <Button
            onClick={onStartOver}
            className="w-5/12  mx-3 md:mx-0 p-4 bg-gray-100 hover:bg-gray-200 font-medium text-gray-600 hover:text-gay-700 border-gray-200"
          >
            CANCEL
          </Button>
          <Button
            onClick={resetForm}
            className="w-5/12 font-medium mx-3 md:mx-0 p-4 bg-native-200 hover:bg-native-300 shadow-lg border-native-200"
          >
            START OVER
          </Button>
        </section>
      </Modal>
    </div>
  );
}
